import React, {useEffect} from "react";
import { Col, Row, Spinner} from "reactstrap";
import {useTranslation} from "react-i18next";
import {CustomInput} from "../../Common/Components/Input/CustomInput";
import {CustomSubmitButton} from "../../Common/Components/Input/CustomSubmitButton";
import RequestSwedbankPay from "../Models/Request/RequestSwedbanPay";
import {InputMessage} from "../../AppSystem/Helpers/InputMessage";
import { BsArrowLeftRight } from 'react-icons/bs';
import $ from "jquery";

export function CreateFormSwedbankPay({ data, costBearerArray = [], accountingArray = [], onChange, onValidate, onValidateCopy, displaySpinner,amountInclVatInput,
    setAmountInclVatInput,
    amountExclVatAndFeeInput,
    setAmountExclVatAndFeeInput,
    setActiveField,}) {
    const { t } = useTranslation()

    // CHECK NUMBER FORMAT
    const checkNumberFormat = (e, name) => {
        const key = e.key;
        const currentValue = e.target.value;
        const isValidChar = key >= '0' && key <= '9';
        const hasReachedMaxLength = currentValue.replace(/[^0-9]/g, '').length >= (name === "accountNumber" ? 12 : 5);
        if (!isValidChar || hasReachedMaxLength) {
            e.preventDefault();
        }
    }

    useEffect(() => {
        if (data?.accountNumber) {
            const accountNumberInput = document.getElementsByName('accountNumber');
            if (accountNumberInput.length > 0) {
                accountNumberInput[0].addEventListener('keypress', function (e) {
                    checkNumberFormat(e, "accountNumber");
                });
            }
        }
    }, [data?.accountNumber]);

    const messageCostBearer = InputMessage(costBearerArray, data?.costBearerId);

    return (
        <>
                <Row>
                    <Col lg={6} className="pt-4">
                        <Row>
                            <Col lg={12}>
                                <CustomInput model={RequestSwedbankPay} attribute='header' data={data?.header} customChange={(e) => {
                                    onChange(e, "header");
                                }} customOptions={costBearerArray.length > 0 ? costBearerArray : null}/>
                            </Col>
                            <Col lg={12}>
                                <CustomInput model={RequestSwedbankPay} attribute='description' data={data?.description} customChange={(e) => {
                                    onChange(e, "description");
                                }} />
                            </Col>
                            <Row className="align-items-center px-0 mx-0">
                                <Col>
                                    <CustomInput 
                                        model={RequestSwedbankPay} 
                                        attribute='amount'
                                        data={amountInclVatInput}
                                        customChange={(e) => {
                                            setActiveField('inclVat');
                                            setAmountInclVatInput(e.target.value);
                                        }} 
                                    />
                                </Col>
                                <Col xs="auto" className="d-flex justify-content-center mx-2 mt-3 mt-md-3">
                                    <BsArrowLeftRight color="green" size={20} />
                                </Col>
                                <Col >
                                    <CustomInput 
                                        model={RequestSwedbankPay} 
                                        attribute='amountExclVatAndFee' 
                                        data={amountExclVatAndFeeInput}
                                        customChange={(e) => {
                                            setActiveField('exclVat'); 
                                            setAmountExclVatAndFeeInput(e.target.value);
                                        }} 
                                    />
                                </Col>
                            </Row>
                        </Row>
                    </Col>
                    <Col lg={6} className="pt-4">
                        <Row>
                            <Col lg={12}>
                                <CustomInput model={RequestSwedbankPay} attribute='email' data={data?.email} customChange={(e) => {
                                    onChange(e, "email");
                                }} />   
                            </Col>
                            <Col lg={12}>
                                <CustomInput model={RequestSwedbankPay} attribute='costBearerId' data={data?.costBearerId} customChange={(e) => {
                                    onChange(e, "costBearerId");
                                }} customOptions={costBearerArray.length > 0 ? costBearerArray : null}/>
                                {messageCostBearer}
                            </Col>                                                  
                        </Row>
                    </Col>
                </Row>
                <Row className="d-flex justify-content-end">
                    <Col className="text-end col-12 d-flex justify-content-end align-items-stretch">
                        {displaySpinner === true ?
                            <>
                                <span className="me-2">{t('validationMessage.sendingPay')}</span>
                                <Spinner color='success' className="me-3"/>
                            </>
                        : ""}
                        <CustomSubmitButton text={t('button.sendAndCreateCopy')} icon = "bx bx-copy pe-2" id='submitCopy' customClasses="ms-3 p-1 bg-green px-3 px-lg-4"  customClick={async () => {
                            onValidateCopy();
                            $("#submit").prop("disabled", true);
                            $("#submitCopy").prop("disabled", true);
                        }} />
                        <CustomSubmitButton text={t('button.send')}  id='submit' icon='bx bx-send pe-2' customClass="ms-3 p-1 bg-green px-3 px-lg-4" customClick={async () => {
                            onValidate();
                            $("#submit").prop("disabled", true);
                            $("#submitCopy").prop("disabled", true);
                        }} />
                    </Col>
                </Row>
        </>
    );
}